import { finalize } from 'rxjs/operators';
import {
  AfterContentInit,
  Component,
  Input
} from '@angular/core';
import { Color } from 'chart.js';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { ProfileService } from '../../../services/profile.services';
import { Configuration } from '../../conf/app.constants';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { OnDestroy } from '@angular/core';


@Component({
  selector: 'frameworkAgreementProgressGraph',
  templateUrl: 'frameworkAgreementProgressGraph.template.html'
})
export class FrameworkAgreementProgressGraphComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  @Input()
  public dossier: any;

  loaded = false;
  graphicLoaded = false;

  chartTopType = 'doughnut';
  chartTopLabels: string[];
  chartTopData: any[];
  chartColors: Array<Color> = [];
  totalProgress: string;
  chartOptions: any;
  loadedProgressData: Array<any>;
  chartShowLot = false;
  filteredData: any[];
  lots: string[];
  activeLotDesc: string;

  constructor(
    public uiService: UIService,
    public plycaService: PlycaDataService,
    protected route: ActivatedRoute,
    protected waitService: WaitLoadingService,
    public dialogService: DialogService,
    public translate: TranslateService,
    public configuration: Configuration,
    public profileService: ProfileService,
    protected router: Router,
    public userService: UserService,
  ) {
    super();
  }

  ngAfterContentInit(): void {
    console.log('cargando grafico');
    this.chartOptions = Object.assign({}, this.uiService.pChartOptions);
    if (!this.chartOptions.tooltips) {
      this.chartOptions.tooltips = { enabled: false };
    } else {
      this.chartOptions.tooltips.enabled = false;
    }

    this.dossier['PROC_LETTERS'] = '';
    if (
      this.dossier &&
      this.dossier.division &&
      this.dossier.division.procedure
    ) {
      this.dossier['PROC_LETTERS'] = this.calculateLetters(
        this.dossier.division.procedure.description
      );
    }
    this.loadGraphicData();
    this.loaded = true;
    console.log('Grafico cargado');
  }

  processChartData(activeLot?: string): void {
    let labels: string[] = [];
    let dataList: any[] = [];
    let data0: any = { data: [] };
    let data: any[] = [data0];
    let colors: Array<Color> = [];
    this.lots = [];
    colors[0] = Object.assign({}, this.uiService.chartColorsDef);
    // let backgroundColor: string[] = Object.assign(
    //   [],
    //   this.uiService.chartColorsDef.backgroundColor
    // );
    // let borderColor: string[] = Object.assign(
    //   [],
    //   this.uiService.chartColorsDef.borderColor
    // );
    // let hoverBackgroundColor: string[] = Object.assign(
    //   [],
    //   this.uiService.chartColorsDef.hoverBackgroundColor
    // );
    // (<string[]>colors[0].backgroundColor) = backgroundColor;
    // (<string[]>colors[0].borderColor) = borderColor;
    // (<string[]>colors[0].hoverBackgroundColor) = hoverBackgroundColor;

    let sumProgress = 0;
    let sumTotalEstiamted = 0;
    let sumEstiamted = 0;
    let sumAwarded = 0;
    let countLots = 0;

    this.chartShowLot = false;
    if (activeLot) {
      this.chartShowLot = true;
    }

    for (let dato of this.loadedProgressData) {
      if (!activeLot || dato.columns.LOTE.value === activeLot) {
        countLots += 1;
        sumProgress += Number(dato.columns.PORCEN_DISP.value);
        sumTotalEstiamted += Number(dato.columns.VALORESTIMADO.value);
        sumEstiamted += Number(dato.columns.IMP_PREVISTO.value);
        sumAwarded += Number(dato.columns.IMP_ADJ.value);
        this.activeLotDesc = '';
        if (dato.columns.LOTE.value == '') {
          labels.push(this.translate.instant('DossierBasicInfo.frameworkaggrement.avalilableBalance'));
          this.lots.push('0');
        } else {
          labels.push(this.translate.instant('DossierBasicInfo.frameworkaggrement.avalilableBalance') + ': ' + dato.columns.LOTE.value);
          this.lots.push(dato.columns.LOTE.value);
        }
        if (activeLot) {
          this.activeLotDesc = dato.columns.LOTE.value;
        }
        dataList.push(dato.columns);
        let value: number = Number(dato.columns.VALORESTIMADO.value)
          - Number(dato.columns.IMP_PREVISTO.value) - Number(dato.columns.IMP_ADJ.value);
        data0.data.push(value);
      }
    }
    // this.totalProgress = (100 - (sumProgress / countLots)) + '%';
    this.totalProgress = (100 - Math.round(((sumEstiamted + sumAwarded) / sumTotalEstiamted) * 100)) + '%';

    labels.push(this.translate.instant('DossierBasicInfo.frameworkaggrement.awardedInBasedContracts'));
    data0.data.push(Number(sumAwarded));
    // (<string[]>colors[0].backgroundColor)[data0.data.length - 1] =
    //   'rgba(230,230,230,255)';
    // (<string[]>colors[0].borderColor)[data0.data.length - 1] =
    //   'rgba(0,0,0,0)';
    // (<string[]>colors[0].hoverBackgroundColor)[data0.data.length - 1] =
    //   'rgba(230,230,230,255)';

    labels.push(this.translate.instant('DossierBasicInfo.frameworkaggrement.plannedAmountInBasedContracts'));
    data0.data.push(Number(sumEstiamted));
    // (<string[]>colors[0].backgroundColor)[data0.data.length - 1] =
    //   'rgba(210,210,210,255)';
    // (<string[]>colors[0].borderColor)[data0.data.length - 1] =
    //   'rgba(0,0,0,0)';
    // (<string[]>colors[0].hoverBackgroundColor)[data0.data.length - 1] =
    //   'rgba(210,210,210,255)';
    this.chartTopLabels = labels;
    this.chartTopData = [];
    this.chartTopData['datasets'] = [];
    // this.chartTopData['labels'] = labels;

    let dataElement = {
      // El color de los puntos
      borderColor: this.uiService.borderColor,
      // El color de las líneas
      backgroundColor: this.uiService.backgroundColor,
      fill: true,
      borderWith: 2,
      legend: {
        display: false,
      },
      // options: this.uiService.pChartOptions,
    };
    // dataElement['label'] = 'uno';
    dataElement['data'] = data0['data'];

    this.chartTopData['datasets'].push(dataElement);

    this.chartOptions = this.uiService.barChartOptions;
    this.filteredData = dataList;
    this.graphicLoaded = labels.length > 0;
    this.chartColors = colors;
    setTimeout(() => {
      this.chartColors = colors;
    }, 5);
  }

  isGraphicLoaded() {
    return this.graphicLoaded;
  }

  chartClicked(e: any): void {
    let val = -1;
    if (e) {
      val = e.element.index;
    }
    if (!this.chartShowLot && this.lots.length > 1) {
      let activeLot: string = this.lots[val];
      this.processChartData(activeLot);
    }
  }

  loadGraphicData(): void {
    this.subscribe(this.plycaService
      .getAttributeValue(
        'GRADO_CONTRATACION_AM_SDA_STD',
        'PROPUESTAID=' + this.dossier.identifier
      ).pipe(finalize(() => { this.waitService.cancelWaiting() })),
      x => {
        if (x.values) {
          this.loadedProgressData = x.values;
          this.processChartData();
        }
      },
      err => {
        console.log('Error cargando datos atributo: GRADO_CONTRATACION_AM_SDA_STD');
        console.log(err);
      }
    );
  }

  calculateLetters(originalText: string): string {
    let txt = '';
    if (originalText) {
      let words: string[] = originalText.split(' ');
      for (let entry of words) {
        txt = txt + entry.slice(0, 1).toUpperCase();
      }
    }
    return txt;
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  isChartShowLot(): boolean {
    return this.chartShowLot;
  }
}
